<div class="fixed top-16 left-1/2 -translate-x-1/2 z-40 flex flex-col gap-2 w-80 pointer-events-none">
  <!-- General toasts (success / error) -->
  @for (toast of toastService.toasts(); track toast.id) {
    <div
      [class]="'rounded-lg shadow-lg border p-3 animate-slide-in pointer-events-auto flex items-center justify-between gap-2 ' +
        (toast.type === 'success' ? 'bg-green-50 border-green-200' : 'bg-red-50 border-red-200')"
      data-testid="general-toast"
    >
      <div class="flex items-center gap-2 min-w-0">
        @if (toast.type === 'success') {
          <svg class="h-4 w-4 text-green-600 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
          </svg>
        } @else {
          <svg class="h-4 w-4 text-red-600 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v2m0 4h.01M12 3l9.66 16.59A1 1 0 0120.66 21H3.34a1 1 0 01-.86-1.41L12 3z" />
          </svg>
        }
        <p [class]="'text-sm ' + (toast.type === 'success' ? 'text-green-800' : 'text-red-800')">{{ toast.message }}</p>
      </div>
      <button (click)="dismissToast(toast.id)" class="text-gray-400 hover:text-gray-600 shrink-0 p-0.5">
        <svg class="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  }

  <!-- Deadline alert toasts -->
  @for (alert of notifications.toasts(); track alert.key) {
    <div class="bg-white rounded-lg shadow-lg border border-gray-200 p-4 animate-slide-in pointer-events-auto" data-testid="toast-item">
      <div class="flex items-start justify-between gap-2">
        <div (click)="openAlert(alert)" class="flex-1 min-w-0 cursor-pointer">
          <p class="text-sm font-semibold text-gray-900">{{ alert.title }}</p>
          <p class="text-xs text-gray-600 mt-0.5">{{ alert.subtitle }}</p>
          <p
            [class]="'text-xs mt-1 ' + (alert.days_remaining <= 0 ? 'text-red-700 font-bold' : alert.days_remaining <= 7 ? 'text-red-600 font-semibold' : alert.days_remaining <= 14 ? 'text-yellow-600 font-semibold' : 'text-blue-600')"
          >
            @if (alert.days_remaining < 0) {
              {{ -alert.days_remaining }} napja lejárt!
            } @else if (alert.days_remaining === 0) {
              Ma jár le!
            } @else {
              {{ alert.days_remaining }} nap múlva lejár
            }
          </p>
        </div>
        <div class="flex gap-1">
          <button (click)="mute(alert)" data-testid="toast-mute" class="text-gray-400 hover:text-red-500 p-0.5" title="Ne jelenjen meg többé">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z" />
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2" />
            </svg>
          </button>
          <button (click)="dismiss(alert)" data-testid="toast-dismiss" class="text-gray-400 hover:text-gray-600 p-0.5" title="Elvetés">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  }
</div>
